<template>
  <v-card 
    style="max-width: 100%; width: 100%"
  >
    <v-toolbar
      flat
    >
      <v-text-field 
        v-if="editionMode"
        v-model="label" 
        :placeholder="$t('campaigns.label.sessionPlaceholder')" 
        persistent-placeholder 
        :hint="$t('campaigns.label.sessionHint')"
      ></v-text-field>
      <v-card-title
        v-else 
      >
        {{ label }}
      </v-card-title>
      <v-text-field
        v-if="editionMode"
        :label="$t('campaigns.label.duration')"
        v-model="duration"
        class="ml-5"
        suffix="h:min:s"
        style="max-width: 11em;"
      ></v-text-field>
      <v-chip v-else color="grey--lighten">{{ humanizedDuration }}</v-chip>
      <v-chip v-if="!editionMode" class="ml-5">
        {{ $t('campaigns.label.splitSize2', {splitSize}) }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-btn
        v-if="editionMode"
        icon
        @click="deleteItem"
      >
        <v-icon>{{ session.existing ? 'mdi-delete' : 'mdi-close' }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid class="py-0">
      <v-row v-if="editionMode">    
        <!-- <v-col cols="2" class="pt-5">
        </v-col> -->
        <v-col cols="12" class="py-0">
          <!-- <v-subheader class="pl-0">
            {{ $t('campaigns.label.splitSize') }}
          </v-subheader> -->
          <v-slider
            dense
            :label="$t('campaigns.label.splitSize')"
            :disabled="!editionMode"
            class="pt-5"
            v-model="splitSize"
            min="0"
            :max="maxSplitSize"
            @mousedown="overSlider(true)" 
            @mouseup="overSlider(false)"
          >
            <template v-slot:append>
              <div>
                <div class="d-inline-block">
                  <v-chip>
                    {{ splitSize }}%
                  </v-chip>
                </div>
                <div class="d-inline-block" style="width: 50px;">
                </div>
              </div>
              <!-- <v-text-field
                v-model="splitSize"
                class="mt-0 pt-0"
                type="number"
                style="width: 60px"
              ></v-text-field> -->
            </template>
          </v-slider>
        </v-col>
      </v-row>
      <v-row v-if="editionMode || session.reconciliationUsername">
        <v-col cols="4" :class="editionMode ? '' : 'ml-5'">
          <v-card-text>{{ $t('campaigns.label.reconciliationUser') }}</v-card-text>
        </v-col>
        <v-col cols="6">
          <v-select
            dense
            v-if="editionMode"
            clearable
            v-model="reconciliationUsername"
            :items="availableReconciliationUsersPlusCurrent"
            item-text="profilename"
            item-value="username"
            persistent-hint
            style="max-width: 300px"
          ></v-select>
          <v-chip v-else-if="session.reconciliationUsername" class="ml-5">
            {{ reconciliationUsername }}
          </v-chip>

        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  props: ["editionMode", "sessionIdx", "session", "remainingSplitSize", "jsonpath", "availableUsers", "availableReconciliationUsers" ],
  data() {
    return {
      maxOnEnter: 0,
      over: false,
    }
  },
  computed: {
    humanizedDuration() {
      if (this.editionMode) {
        return ""
      }
      // can't get this working
      // https://momentjs.com/docs/#/durations/
      // https://momentjs.com/docs/#/i18n/instance-locale/
      // const localized = moment()
      // localized.locale(this.$i18n.locale)
      //return localized.duration(1000*this.duration).humanize()
      return moment.duration(this.duration).humanize({m: 60, s: 60})
    },
    label: {
      get() {
        const label = this.session.label;
        return label ? label : ""
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { label: value }}})
      }
    },
    duration: {
      get() {
        const duration = this.session.duration;
        return duration ? duration : "00:00:00"
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { duration: value }}})
      }
    },
    maxSplitSize() {
      return this.over ? this.maxOnEnter : (this.splitSize + this.remainingSplitSize);
    },
    splitSize: {
      get() {
        const splitSize = this.session.splitSize;
        return splitSize ? splitSize : 0
      },
      set(value) {
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { splitSize: value }}})
      }
    },
    reconciliationUsername: {
      get() {
        const reconciliationUsername = this.session.reconciliationUsername;
        return reconciliationUsername ? reconciliationUsername : null
      },
      set(value) {
        if (!value) {
          value = null
        }
        this.$emit("change", {jsonpath: this.jsonpath, op: { name: "patch", value: { reconciliationUsername: value }}})
      }
    },
    availableReconciliationUsersPlusCurrent() {
      const username = this.session.reconciliationUsername
      if (username) {
        return [{username, profilename: username}, ...this.availableReconciliationUsers]
      } else {
        return this.availableReconciliationUsers;
      }
    }
  },
  methods: {
    deleteItem() {
      this.$emit("delete", this.sessionIdx)
    },
    overSlider(over) {
      this.over = over
      if (over) {
        this.maxOnEnter = this.splitSize + this.remainingSplitSize
      }
    },
  },

}
</script>